/**
 * AcquiredBooksRouter — mode-aware dispatch for /reports/acquired-books.
 *
 * Reads `companyData.loanBookMode` from outlet context and renders either
 *   • the legacy `AcquiredBooksPage` (Entourage etc.) — file untouched,
 *     SHA frozen, byte-identical behaviour preserved, OR
 *   • the new `AcquiredBooksEntityPage` (Timms, Intuitive Finance, all
 *     future unified-mode tenants) which sources templates from the
 *     `loan_books` subcollection and threads entity codes through to
 *     `getAcquiredBookMetrics` and `getLostLoans`.
 *
 * AppLayout already gates `<Outlet>` on `userLoading || companyLoading`, so
 * `companyData` is non-null by the time this router mounts. The explicit
 * null guard is belt-and-braces against future loading-state regressions.
 */

import React from 'react';
import { useOutletContext } from 'react-router-dom';
import AcquiredBooksPage from './AcquiredBooksPage';
import AcquiredBooksEntityPage from './AcquiredBooksEntityPage';

const AcquiredBooksRouter: React.FC = () => {
  const ctx = useOutletContext<{ companyData?: { loanBookMode?: string } | null } | undefined>();
  const companyData = ctx?.companyData;

  if (!companyData) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400">Loading company configuration...</p>
      </div>
    );
  }

  return companyData.loanBookMode === 'unified'
    ? <AcquiredBooksEntityPage />
    : <AcquiredBooksPage />;
};

export default AcquiredBooksRouter;
